import { useState, useEffect } from 'react';
import { clearImageNotFound, reportImageNotFound } from './imageNotFound';

export const useImage = (src) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [hasStartedInitialFetch, setHasStartedInitialFetch] = useState(false);

  const heap = window?.heap;

  useEffect(() => {
    let isMounted = true;
    let reportedNotFound = false;
    if (isMounted) {
      setHasStartedInitialFetch(true);
      setHasLoaded(false);
      setHasError(false);
    }

    // Here's where the magic happens.
    const image = new Image();
    image.src = src;
    const start = Date.now();

    const handleError = () => {
      if (isMounted) {
        const duration = Date.now() - start;
        heap.track('BYO-Image-Load', {load: 'error', 'duration': duration, 'src': src});
        setHasError(true);
        // The image error event does not expose the HTTP status, and the CGI
        // host omits CORS headers on error responses, so any load failure counts.
        reportedNotFound = true;
        reportImageNotFound(src);
      }
    };

    const handleLoad = () => {
      if (isMounted) {
        const duration = Date.now() - start;
        heap.track('BYO-Image-Load', {load: 'success', 'duration': duration, 'src': src});
        setHasLoaded(true);
        setHasError(false);
      }
    };

    image.onerror = handleError;
    image.onload = handleLoad;

    return () => {
      isMounted = false;
      if (reportedNotFound) {
        clearImageNotFound(src);
      }
      image.removeEventListener('error', handleError);
      image.removeEventListener('load', handleLoad);
    };
  }, [src]);

  return { hasLoaded, hasError, hasStartedInitialFetch };
};

export default useImage;
